import { SessionSchema } from '@/types/schema';

export const getTickFormat = (
  tick: number,
  maxCharacters: number,
  rowData: SessionSchema[],
  experimentMetadataPath?: string,
  useNameAsDefault?: boolean
) => {
  const sessionObj = rowData.find((row) => row.test_run_number === tick);
  const defaultTick = useNameAsDefault
    ? truncatedTitle(sessionObj?.name || `#${tick}`, maxCharacters)
    : `#${tick}`;

  if (!experimentMetadataPath || !sessionObj) return defaultTick;

  const metadataTitle = experimentMetadataPath
    ? sessionObj.extra?.metadata?.[experimentMetadataPath]
    : undefined;
  if (!metadataTitle || typeof metadataTitle !== 'string') return defaultTick;
  return truncatedTitle(metadataTitle, maxCharacters);
};

const truncatedTitle = (title: string, maxCharacters: number) => {
  return title.length > maxCharacters
    ? `${title.slice(0, maxCharacters)}...`
    : title;
};
